import React from 'react';
import CenterContent from 'components/CenterContent';
var ERROR_DETAILS = {
  code: 'IMAGE_LOAD_ERR',
  message: 'Failed to load graphic from the network'
};
function ImageViewer(_ref) {
  var imageUrl = _ref.imageUrl,
    _ref$alternativeText = _ref.alternativeText,
    alternativeText = _ref$alternativeText === void 0 ? '' : _ref$alternativeText,
    onLoad = _ref.onLoad,
    _onError = _ref.onError;
  return /*#__PURE__*/React.createElement(CenterContent, {
    fillParent: true,
    spacing: "m"
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    alt: alternativeText,
    onLoad: onLoad,
    onError: function onError() {
      _onError === null || _onError === void 0 ? void 0 : _onError(ERROR_DETAILS);
    },
    style: {
      maxWidth: '100%'
    }
  }));
}
export default ImageViewer;